import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

//import { version } from 'package.json'
import packageInfo from '../../package.json';
import { ModalChangelogComponent } from './modals/modal-changelog/modal-changelog.component';
import { PresenceService } from './services/presence.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'kioskv2';
  dialogRef: any;
  appVersion: any;
  constructor(public dialog: MatDialog, public presence: PresenceService) {
    console.log("VERSION:", packageInfo.version)

    this.appVersion = packageInfo.version
  }


  openChangelog() {
    this.dialogRef = this.dialog.open(ModalChangelogComponent, {
      'height': '90vh',
      'width': '50vw;'
    });


  }


}
